import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

import EventBus from './utils/event-bus'
import QrcodeVue from 'qrcode.vue';

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Multiselect from "vue-multiselect";
Vue.component('multiselect', Multiselect);
import 'vue-multiselect/dist/vue-multiselect.min.css'

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask);

import Loading from 'vue-loading-overlay'
Vue.use(Loading);
import 'vue-loading-overlay/dist/vue-loading.css'

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
import 'sweetalert2/dist/sweetalert2.min.css'


import 'pretty-checkbox/dist/pretty-checkbox.css'

import Payment from 'payment/lib'

import Card from './components/General/Card/Card'
Vue.component('Card', Card);

import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import CpfValidator from './utils/validators/cpf/cpf.validator'
import pt_BR from 'vee-validate/dist/locale/pt_BR'
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('QrcodeVue', QrcodeVue)

extend('cpf', {
  ...CpfValidator,
  message: "O campo {_field_} possui um CPF inválido"
})

// Validation Rules
for (let rule in rules) {
  extend(rule, {
    ...rules[rule],
    message: pt_BR.messages[rule]
  });
}

extend('cardNumber', {
  message: 'O campo {_field_} é inválido.',
  validate: value => Payment.fns.validateCardNumber(value)
});

extend('cardExpiry', {
  message: 'O campo {_field_} deve ter uma data futura.',
  validate: value => {
    let parts = value.split('/');
    return Payment.fns.validateCardExpiry(parts[0], parts.length > 1 ? parts[1] : '');
  }
});

extend('cardCvc', {
  message: 'O campo {_field_} deve ter 3 ou 4 dígitos.',
  validate: value => Payment.fns.validateCardCVC(value)
});

Vue.config.productionTip = false

import Api from './utils/api'
Vue.prototype.api = Api;

import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import { extendMoment } from 'moment-range'
extendMoment(moment);
momentDurationFormatSetup(moment);
Vue.prototype.moment = moment;
Vue.prototype.moment.locale('pt-BR');
Vue.prototype.eventBus = EventBus;

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
